module.exports = __webpack_public_path__ + "img/Ukraine.249f5a6d.gif";